/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquarePercent: {
  name: 'square-percent';
  data: string;
} = {
  name: 'square-percent',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h14v14H5V5Zm5.707 9.707 4-4a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 1 0 1.414 1.414ZM9 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm5 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" fill="currentColor"/></svg>`,
};
